import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/banner.jpeg'


const _hoisted_1 = { class: "layout" }
const _hoisted_2 = { id: "nav" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "mb-4",
  src: _imports_0
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Top")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Token")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Videos")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Nominations")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("About")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Goods")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Languages = _resolveComponent("Languages")!
  const _component_Connect = _resolveComponent("Connect")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_router_link, {
        to: _ctx.localizedUrl('/'),
        class: "text-2xl font-londrina"
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["to"]),
      _hoisted_5,
      _createVNode(_component_router_link, {
        to: _ctx.localizedUrl('/nft'),
        class: "text-2xl font-londrina"
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["to"]),
      _hoisted_7,
      _createVNode(_component_router_link, {
        to: _ctx.localizedUrl('/videos'),
        class: "text-2xl font-londrina"
      }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      }, 8, ["to"]),
      _hoisted_9,
      _createVNode(_component_router_link, {
        to: _ctx.localizedUrl('/nomi'),
        class: "text-2xl font-londrina"
      }, {
        default: _withCtx(() => [
          _hoisted_10
        ]),
        _: 1
      }, 8, ["to"]),
      _hoisted_11,
      _createVNode(_component_router_link, {
        to: _ctx.localizedUrl('/about'),
        class: "text-2xl font-londrina"
      }, {
        default: _withCtx(() => [
          _hoisted_12
        ]),
        _: 1
      }, 8, ["to"]),
      _hoisted_13,
      _createVNode(_component_router_link, {
        to: _ctx.localizedUrl('/shop'),
        class: "text-2xl font-londrina"
      }, {
        default: _withCtx(() => [
          _hoisted_14
        ]),
        _: 1
      }, 8, ["to"]),
      _createVNode(_component_Languages, { class: "mt-4" }),
      _createVNode(_component_Connect)
    ]),
    _createVNode(_component_router_view)
  ]))
}